import { configureStore } from "@reduxjs/toolkit";
import SaleProducts from "./saleProductSlice.js";
import CommonProducts from "./commonProductSlice.js";
import NewProducts from "./newProductSlice.js";

export default configureStore({
    reducer:{
        saleProducts: SaleProducts,
        commonProducts: CommonProducts,
        newProducts: NewProducts,
    }
});